export type ActionItemSourceKindValue =
  | 'meeting'
  | 'topic'
  | 'rock'
  | 'metric'
  | 'milestone'

export interface ActionItemSourceKind {
  value: ActionItemSourceKindValue
  label: string
}

export const ACTION_ITEM_SOURCE_KINDS: readonly ActionItemSourceKind[] = [
  { value: 'meeting', label: 'Meeting' },
  { value: 'topic', label: 'Topic' },
  { value: 'rock', label: 'Rock' },
  { value: 'metric', label: 'Metric' },
  { value: 'milestone', label: 'Milestone' },
] as const

const SOURCE_KIND_ALIASES: Record<string, ActionItemSourceKindValue> = {
  meeting: 'meeting',
  Meeting: 'meeting',
  topic: 'topic',
  Topic: 'topic',
  rock: 'rock',
  Rock: 'rock',
  metric: 'metric',
  Metric: 'metric',
  milestone: 'milestone',
  Milestone: 'milestone',
  RockMilestone: 'milestone',
}

export function normalizeSourceKind(
  raw: string | null | undefined,
): ActionItemSourceKindValue | '' {
  if (!raw) return ''
  return SOURCE_KIND_ALIASES[raw] ?? ''
}

export function sourceKindLabel(
  raw: string | null | undefined,
): string | null {
  const kind = normalizeSourceKind(raw)
  if (!kind) return null
  return ACTION_ITEM_SOURCE_KINDS.find(k => k.value === kind)?.label ?? null
}

export interface ActionItemSourceOption {
  id: number
  label: string
}

export type ActionItemSourceOptions = Partial<
  Record<ActionItemSourceKindValue, ActionItemSourceOption[]>
>
